<template>
    <div class="login">
        <!-- Login -->
        <div class="login__block animated" :class="this.view === 'login' ? 'fadeInLeft' : 'fadeOutRight'" id="l-login">
            <div class="login__block__header">
                <i class="zmdi zmdi-account-circle"></i>
                Hi there! Please Sign in
            </div>

            <div class="login__block__body">
                <form @submit.prevent="attemptLogin" ref="loginForm" data-vv-scope="login" novalidate>

                    <div class="alert alert-danger" v-if="errors.has('login.global')">{{ errors.first('login.global') }}</div>

                    <div class="form-group form-group--centered" :class="{'has-danger': errors.has('login.email')}">
                        <input type="email" name="email" autocomplete="username" v-validate="validation.email" v-model="email"
                               placeholder="Email Address" class="form-control" required>
                        <div class="invalid-feedback" v-if="errors.has('login.email')">{{ errors.first('login.email') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                    <div class="form-group form-group--centered" :class="{'has-danger': errors.has('login.password')}">
                        <input type="password" name="password" autocomplete="current-password" v-validate="validation.password" v-model="password" placeholder="Password"
                               class="form-control" required>
                        <div class="invalid-feedback" v-if="errors.has('login.password')">{{ errors.first('login.password') }}</div>
                        <i class="form-group__bar"></i>
                    </div>

                    <button type="submit" class="btn btn-success">
                        Sign In
                    </button>
                </form>
            </div>

            <div class="login__block__footer">
                <span class="text-muted">Not a primary Origin user?</span>
                <a @click.prevent="showRegister()">Create an account!</a>
            </div>
            <hr>
            <div class="login__block__footer">
                <a href="http://legacy.primaryorigin.co.nz">Go to the legacy system <i class="zmdi zmdi-arrow-forward"></i></a>
            </div>
        </div>

        <b-modal id="termsModal" title="Website usage terms and conditions" ok-only>
            <TermsAndConditions />

        </b-modal>

        <!-- Register -->
        <div class="login__block animated" :class="this.view === 'register' ? 'fadeInLeft' : 'fadeOutRight'" id="l-register">
            <div class="login__block__header palette-Blue bg">
                <i class="zmdi zmdi-account-circle"></i>
                Create an account
            </div>

            <div class="alert alert-danger" v-if="errors.has('register.global')">{{ errors.first('register.global') }}</div>

            <div class="login__block__body">

                <form @submit.prevent="attemptRegister" ref="registerForm" data-vv-scope="register" novalidate>
                    <div class="form-group form-group--centered" :class="{'has-danger': errors.has('register.name')}">
                        <input type="name" name="name" v-validate="validation.name" v-model="name"
                               placeholder="Your Name" class="form-control" required>
                        <div class="invalid-feedback" v-if="errors.has('register.name')">{{ errors.first('register.name') }}</div>
                        <i class="form-group__bar"></i>
                    </div>

                    <div class="form-group form-group--centered" :class="{'has-danger': errors.has('register.business_name')}">
                        <input type="text" name="business_name" data-vv-as="business name" v-validate="validation.business_name" v-model="business_name"
                               placeholder="Business Name" class="form-control" required>
                        <div class="invalid-feedback" v-if="errors.has('register.business_name')">{{ errors.first('register.business_name') }}</div>
                        <i class="form-group__bar"></i>
                    </div>

                    <div class="form-group form-group--centered" :class="{'has-danger': errors.has('register.email')}">
                        <input type="email" name="email" autocomplete="username" v-validate="validation.email" v-model="email"
                               placeholder="Email Address" class="form-control" required>
                        <div class="invalid-feedback" v-if="errors.has('register.email')">{{ errors.first('register.email') }}</div>
                        <i class="form-group__bar"></i>
                    </div>

                    <div class="form-group form-group--centered" :class="{'has-danger': errors.has('register.password')}">
                        <input type="password" name="password" v-validate="validation.password" v-model="password"
                               placeholder="Password" class="form-control" autocomplete="new-password" required>
                        <div class="invalid-feedback" v-if="errors.has('register.password')">{{ errors.first('register.password') }}</div>
                        <i class="form-group__bar"></i>
                    </div>

                    <div class="form-group form-group--centered" :class="{'has-danger': errors.has('register.type')}">
                        <div class="position-relative">
                            <VueSelect
                                    v-validate="validation.user_type"
                                    data-vv-name="user_type"
                                    data-vv-as="user type"
                                    data-vv-scope="register"
                                    v-model="user_type"
                                    :options="['Grower', 'Contractor']"
                                    :allow-empty="false"
                                    deselect-label=""
                                    placeholder="User Type"
                            >
                            </VueSelect>
                            <div class="invalid-feedback" v-if="errors.has('register.user_type')">{{ errors.first('register.user_type') }}</div>
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="form-group form-group--centered" :class="{'has-danger': errors.has('register.region')}">
                        <div class="position-relative">
                            <VueSelect
                                    v-validate="validation.region"
                                    data-vv-name="region"
                                    data-vv-scope="register"
                                    v-model="region"
                                    :options="allCountries"
                                    :allow-empty="false"
                                    deselect-label=""
                                    placeholder="Region"
                                    group-values="regions"
                                    group-label="name"
                                    label="name"
                                    track-by="id"
                            >
                            </VueSelect>
                            <div class="invalid-feedback" v-if="errors.has('register.region')">{{ errors.first('register.region') }}</div>
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="form-group text-left" :class="{'has-danger': errors.has('register.terms')}">
                        <div class="position-relative">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="termsCheck" :value="terms_accepted" name="terms"
                                       v-validate="validation.terms"
                                       data-vv-as="terms and conditions"
                                       data-vv-scope="register" required>
                                <label class="custom-control-label" for="termsCheck">
                                    I have read and accept the <a href="#" v-b-modal.termsModal>terms &amp; conditions</a>.
                                </label>
                            </div>
                            <div class="invalid-feedback" v-if="errors.has('register.terms')">{{ errors.first('register.terms') }}</div>
                        </div>
                    </div>

                    <button type="submit" class="btn btn-success">
                        Register
                    </button>
                </form>
            </div>

            <div class="login__block__footer">
                <span class="text-muted">Already have an account?</span> <a @click.prevent="showLogin()">Sign in instead</a>
            </div>
        </div>
    </div>
</template>

<script>
import TermsAndConditions from '@components/TermsAndConditions';
import RegisterGrowerMutation from '@views/Login/mutationCreateGrower.graphql';
import RegisterContractorMutation from '@views/Login/mutationCreateContractor.graphql';
import LoginMutation from '@views/Login/mutationLogin.graphql';
import listCountriesQuery from '@views/Login/queryListCountries.graphql';

/**
 * @property {VueRouter} $router
 * @property {Validator} $validator
 * @property {ErrorBag} errors
 * @property {object} $refs
 * @property {HTMLFormElement} $refs.loginForm
 * @property {HTMLFormElement} $refs.registerForm
 */
export default {
  name: 'login',
  apollo: {
    allCountries: {
      query: listCountriesQuery,
      skip() {
        return this.view !== 'register';
      },
      update: data => data.filterCountries.data,
    },
  },
  data() {
    return {
      view: 'login',
      email: process.env.NODE_ENV === 'development' ? '@webfox.co.nz' : '',
      password: process.env.NODE_ENV === 'development' ? 'password' : '',
      name: '',
      region: null,
      terms_accepted: false,
      business_name: null,
      user_type: null,
      allCountries: [],
      validation: {
        email: { required: true, email: true },
        name: { required: true },
        business_name: { required: true },
        password: { required: true },
        region: { required: true },
        user_type: { required: true },
        terms: { required: true },
      },
    };
  },
  mounted() {
    setTimeout(() => document.querySelector('#pageLoader').classList.add('fadeOutDown', 'animated'), 1500,);
  },
  methods: {
    showLogin() {
      this.view = 'login';
    },
    showRegister() {
      this.view = 'register';
    },
    showResetPassword() {
      this.view = 'password';
    },
    attemptRegister() {
      this.errors.remove('global.register');
      this.$validator.validateAll('register').then(validationWasSuccessful => {
        this.$refs.registerForm.classList.add('was-validated');
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: this.user_type === 'Grower' ? RegisterGrowerMutation : RegisterContractorMutation,
            variables: {
              registerInput: {
                name: this.name,
                business_name: this.business_name,
                email: this.email,
                password: this.password,
                region_id: this.region.id,
              },
              loginInput: {
                email: this.email,
                password: this.password,
              },
            },
          })
          .then(this.handleLogin)
          .catch(error => {
            window.testError = error;
            if(error.graphQLErrors && error.graphQLErrors[0] && error.graphQLErrors[0].validation) {
              Object.values(error.graphQLErrors[0].validation).reduce( (acc,arr) => [...acc, ...arr], []).forEach(message => {
                this.errors.add({field: 'register.global', msg: message});
              });
            } else {
              this.errors.add({field: 'register.global', msg: 'Something unexpected happened!'});
            }
            console.error(error);
          });
      });
    },
    attemptLogin() {
      console.log('attempting');
      this.errors.remove('login.global');
      this.$validator.validateAll('login').then(validationWasSuccessful => {
        this.$refs.loginForm.classList.add('was-validated');
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: LoginMutation,
            variables: {
              input: {
                email: this.email,
                password: this.password,
              },
            },
          })
          .then(this.handleLogin)
          .catch(error => {
            console.error(error);
          });
      });
    },
    handleLogin({ data: { login: data } }) {
      console.log('handling', data);
      /**
       * @type {object} data
       * @property {string} data.redirect
       * @property {string[]} data.user.enabledFeatures
       * @property {object} data.user.managedAssociation
       * @property {object} data.user.managedAssociation.cropType
       * @property {object} data.user.managedProcessor
       * @property {object} data.user.role
       */
      if (!data.user) {
        this.errors.add({field: 'login.global', msg: 'Invalid credentials!'});
      } else if (data.user.role.name === 'association' && !data.user.managedAssociation) {
        this.errors.add({field: 'login.global', msg: 'Organisation not setup; Please contact an admin'});
      } else if (data.user.role.name === 'association' && !data.user.managedAssociation.cropType) {
        this.errors.add({field: 'login.global', msg: 'Organisation crop type not setup; Please contact an admin'});
      } else if (data.user.role.name === 'processor' && !data.user.managedProcessor) {
        this.errors.add({field: 'login.global', msg: 'Organisation not setup; Please contact an admin'});
      } else {
        window.location.href = data.redirect;
      }
    },
  },
  components: {
    TermsAndConditions,
  },
};
</script>
